import styled from "styled-components";
import { ReservationInfoWrapper } from "../reservationInfo/styles";

interface ContainerProps {
  $isPhone: boolean;
}

interface TextProps {
  $isPhone: boolean;
}

export const GuestDataWrapper = styled(ReservationInfoWrapper)``;

export const DirectPaymentContainer = styled.div<ContainerProps>`
  display: flex;
  margin-bottom: 16px;
  justify-content: space-between;
  gap: ${({ $isPhone }) => ($isPhone ? "12px" : "0")};

  ${({ $isPhone }) =>
    $isPhone &&
    `
    flex-direction: column;
    align-items: flex-start;
  `}
`;

export const DirectPaymentTextContainer = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  gap: ${({ $isPhone }) => ($isPhone ? "8px" : "16px")};
`;

export const DirectPaymentTitle = styled.span<TextProps>`
  font-size: ${({ $isPhone }) => ($isPhone ? "14px" : "16px")};
  color: #000000;
  font-weight: 500;
`;

export const DirectPaymentSubtitle = styled.span<TextProps>`
  font-size: ${({ $isPhone }) => ($isPhone ? "9px" : "10px")};
  color: #000000b2;
  font-weight: 400;
  line-height: 1.2;
`;

export const PhoneInputWrapper = styled.div``;

export const PhoneHelperText = styled.div`
  font-size: 12px;
  color: #6B7280;
  margin-top: 4px;
  font-family: 'Tajawal', sans-serif;
  font-weight: 400;
  line-height: 1.4;
`;
